module.exports = __webpack_public_path__ + "static/media/xx.acedb189.svg";